import { makeAutoObservable } from 'mobx';

import useStore from '@/common/hooks/useStore';
import Storage, { KEY_DEBUG_SETTINGS } from '@/common/services/Storage';

export enum FCRFGradingCaptionLayout {
  OneLine = 'one-line',
  TwoLines = 'two-lines',
}

interface DebugSettings {
  fcrfGradingCaptionLayout?: FCRFGradingCaptionLayout;
}

export class DebugSettingsStore {
  fcrfGradingCaptionLayout: FCRFGradingCaptionLayout;

  constructor() {
    const settings: Nullable<DebugSettings> = Storage.getObject(KEY_DEBUG_SETTINGS, Storage.STORAGE_LOCAL);

    this.fcrfGradingCaptionLayout = settings?.fcrfGradingCaptionLayout ?? FCRFGradingCaptionLayout.OneLine;

    makeAutoObservable(this);
  }

  setFcrfGradingCaptionLayout = (layout: FCRFGradingCaptionLayout) => {
    this.fcrfGradingCaptionLayout = layout;

    Storage.saveObject(KEY_DEBUG_SETTINGS, this.settings, Storage.STORAGE_LOCAL);
  };

  private get settings(): DebugSettings {
    return { fcrfGradingCaptionLayout: this.fcrfGradingCaptionLayout };
  }
}

export const debugSettingsStore = new DebugSettingsStore();

export const useDebugSettingsStore = () => useStore(DebugSettingsStore);

export default DebugSettingsStore;
